var map = {
	"./accept.svg": 41839,
	"./actions/accept.svg": 18258,
	"./actions/add.svg": 84690,
	"./actions/analyse-approve.svg": 96508,
	"./actions/attach_file.svg": 54983,
	"./actions/block.svg": 61022,
	"./actions/cancel.svg": 42734,
	"./actions/check.svg": 31247,
	"./actions/clip.svg": 15900,
	"./actions/confirm.svg": 93250,
	"./actions/create_questionnaire.svg": 174,
	"./actions/delete.svg": 6306,
	"./actions/edit.svg": 64787,
	"./actions/end.svg": 50632,
	"./actions/give-price.svg": 8921,
	"./actions/hide.svg": 67242,
	"./actions/loading.svg": 6655,
	"./actions/pdf.svg": 47030,
	"./actions/penalty.svg": 28126,
	"./actions/postpone.svg": 78000,
	"./actions/print.svg": 76504,
	"./actions/publish.svg": 71258,
	"./actions/resend.svg": 51529,
	"./actions/share.svg": 66431,
	"./actions/to_whom.svg": 1976,
	"./actions/unblock.svg": 9486,
	"./actions/update.svg": 33795,
	"./actions/view-map.svg": 18800,
	"./actions/view.svg": 54388,
	"./add.svg": 38112,
	"./admins.svg": 94076,
	"./arrow-down.svg": 75886,
	"./blind.svg": 92829,
	"./block.svg": 99305,
	"./cancel.svg": 24076,
	"./chat.svg": 20229,
	"./check.svg": 27325,
	"./circle.svg": 38023,
	"./coffee.svg": 55555,
	"./company-info.svg": 92444,
	"./delete.svg": 91734,
	"./discount.svg": 71307,
	"./doc.svg": 10770,
	"./doctor.svg": 97837,
	"./dots.svg": 94186,
	"./download.svg": 4958,
	"./edit.svg": 19855,
	"./email.svg": 58479,
	"./end.svg": 93315,
	"./give-price.svg": 13098,
	"./hamburger.svg": 21713,
	"./hide.svg": 26593,
	"./icon-logo.svg": 64464,
	"./locked.svg": 49854,
	"./medical_card.svg": 58974,
	"./no_image.svg": 99134,
	"./notification.svg": 90312,
	"./pdf.svg": 46589,
	"./phone.svg": 39177,
	"./placemark.svg": 4082,
	"./profile.svg": 97123,
	"./rate.svg": 84635,
	"./search.svg": 41868,
	"./show-eye.svg": 64662,
	"./sidebar/about-app.svg": 64463,
	"./sidebar/about-company.svg": 3490,
	"./sidebar/ai-call-center.svg": 93703,
	"./sidebar/analyzes.svg": 27452,
	"./sidebar/archive.svg": 30013,
	"./sidebar/balance.svg": 2285,
	"./sidebar/black-list.svg": 92355,
	"./sidebar/bonuses.svg": 37041,
	"./sidebar/book.svg": 32532,
	"./sidebar/category.svg": 79791,
	"./sidebar/chat.svg": 76001,
	"./sidebar/clinic.svg": 7609,
	"./sidebar/comments.svg": 70483,
	"./sidebar/contacts.svg": 61098,
	"./sidebar/conversations.svg": 16341,
	"./sidebar/deletion-reasons.svg": 33812,
	"./sidebar/dieta.svg": 1149,
	"./sidebar/discount.svg": 7178,
	"./sidebar/feedbacks.svg": 96426,
	"./sidebar/insurance.svg": 13227,
	"./sidebar/ip_telephony.svg": 66089,
	"./sidebar/list.svg": 43733,
	"./sidebar/map.svg": 4999,
	"./sidebar/medical_cards.svg": 95738,
	"./sidebar/news.svg": 95351,
	"./sidebar/one-id.svg": 4575,
	"./sidebar/orders.svg": 36589,
	"./sidebar/packages.svg": 1443,
	"./sidebar/profession.svg": 84521,
	"./sidebar/professions.svg": 60255,
	"./sidebar/promo_codes.svg": 81280,
	"./sidebar/promoted-users.svg": 56359,
	"./sidebar/questionaree.svg": 16274,
	"./sidebar/rate.svg": 43398,
	"./sidebar/reasons.svg": 75649,
	"./sidebar/registration.svg": 41533,
	"./sidebar/reports.svg": 44626,
	"./sidebar/self_employed_status.svg": 95382,
	"./sidebar/services.svg": 95071,
	"./sidebar/sms-gateway.svg": 37621,
	"./sidebar/support.svg": 22062,
	"./sidebar/symptoms.svg": 36256,
	"./sidebar/technical_support.svg": 33132,
	"./sidebar/users-by-region.svg": 16057,
	"./sidebar/users.svg": 92013,
	"./sidebar/vebinar.svg": 51688,
	"./sidebar/video-podcast.svg": 65814,
	"./sms.svg": 64900,
	"./unlocked.svg": 57848,
	"./video-call.svg": 94194,
	"./view.svg": 12861,
	"./xlsx.svg": 78692,
	"./zip.svg": 26619
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92498;